import { HttpStatusCode } from 'axios';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { useHttp } from '@/composables';

export function useFormSubmit() {
  const router = useRouter();
  const isSubmitting = ref(false);
  const error = ref(null);
  const errors = ref(null);

  const submit = async (modelId, formData, successRoute, endpoint) => {
    isSubmitting.value = true;
    errors.value = null;
    error.value = null;

    const response = await (modelId
      ? useHttp().put(`/${endpoint}/${modelId}`, formData)
      : useHttp().post(`/${endpoint}`, formData));
    if (response.statusCode === HttpStatusCode.Ok) {
      errors.value = null;
      error.value = null;

      if (successRoute) {
        await router.push({ name: successRoute });
      }
    } else {
      error.value = response.exception;
      errors.value = response.errors;
    }

    isSubmitting.value = false;

    return response;
  };

  return {
    isSubmitting,
    error,
    errors,
    submit,
  };
}
